import { render, staticRenderFns } from "./DriveDeadlineForm.vue?vue&type=template&id=10c7d811"
import script from "./DriveDeadlineForm.vue?vue&type=script&lang=js"
export * from "./DriveDeadlineForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports